/**
 * Collection of design tokens for typographic styles. These aliases categorize typography tokens
 * semantically, making them contextually meaningful.
 */ const typographyAliases = {
    body: {
        fontFamily: 'regular',
        lineHeight: 'regular'
    },
    heading: {
        1: {
            fontSize: '7xl',
            fontWeight: 'bolder',
            lineHeight: 'tight'
        },
        2: {
            fontSize: '6xl',
            fontWeight: 'bolder',
            lineHeight: 'tight'
        },
        3: {
            fontSize: '5xl',
            fontWeight: 'bolder',
            lineHeight: 'tight'
        },
        4: {
            fontSize: '4xl',
            fontWeight: 'bold',
            lineHeight: 'tight'
        },
        5: {
            fontSize: '3xl',
            fontWeight: 'bold',
            lineHeight: 'tight'
        },
        6: {
            fontSize: '2xl',
            fontWeight: 'bold',
            lineHeight: 'tight'
        }
    }
};

export { typographyAliases };
//# sourceMappingURL=typography.js.map
